import dayjs from "dayjs";
import SyIcon from "../../../../shared/components/sy-icon";
import { info } from "./config";

const SplashInfoPop = (props: any) => {
  const { handleCloseClick } = props;
  const getTime = (time: any, format: any) => {
    return dayjs(time).format(format);
  };

  return (
    <div className={`rounded-4  p-3   pop-bg`}>
      <div className="d-flex align-items-center justify-content-between pb-3">
        <h2 className="mohave m-0 title-font">{"info"}</h2>
        <SyIcon
          name="close"
          iconType="symbols"
          iconStyle="outlined"
          iconColor="white"
          className={` pointer`}
          onClick={handleCloseClick}
        />
      </div>
      <p className="mohave px-2" dangerouslySetInnerHTML={{ __html: info }}>
      
      </p>
    </div>
  );
};

export default SplashInfoPop;
